import HTForm from '../../_shared/form/htform';
import { observable } from 'mobx';

export default class HomeDetailsForm extends HTForm {
    @observable regions = [];
    @observable allCouncils = [];
    @observable filteredCouncils = [];

    getConsentZoneFromCouncil(region, council) {
        /* eslint-disable no-unused-vars */
        const obj = this.appStore.councils.find(item => {
            return item.Region === region && item.Council === council;
        });

        return obj.ConsentZone;
    }

    updateConsentZoneQuestions() {
        const region = this.$('homedetails.1b.1b-1').get('value'),
            council = this.$('homedetails.1b.1b-2').get('value'),
            franklinCouncil = this.$('homedetails.franklinCouncil').get('value');

        if (!region || !council) return;
        let zone = this.getConsentZoneFromCouncil(region, council),
            label;

        if (franklinCouncil === 'yes') {
            zone = 1;
        } else if (franklinCouncil === 'no') {
            zone = 2;
        }

        switch (zone) {
            case 2:
                label = 'Did your home receive building consent on or after 30 June 2008?';
                break;
            case 3:
                label = 'Did your home receive building consent on or after 31 October 2007?';
                break;
            case 1:
            default:
                label = 'Did your home receive building consent on or after 30 September 2008?';
                break;
        };

        // Set consentZone and update consentZoneCompliant labels
        this.$('homedetails.consentZone').set('value', zone);
        this.$('homedetails.consentZoneCompliant').set('label', label);
    }

    setup() {
        return this.setupHomeDetailsForm();
    }

    setupHomeDetailsForm() {
        const EnableNov2023Onwards = window.HTContent?.EnableNov2023Onwards;

        return {
            fields: [
                {
                    name: 'homedetails',
                    type: 'formsection',
                    label: 'Your home\'s age, location and type',
                    fields: [
                        {
                            name: 'isApartment',
                            type: 'radio',
                            value: '',
                            label: 'Is your home an apartment that is part of a building of at least three storeys, with six or more units?',
                            extra: {
                                options: () => {
                                    return [
                                        {
                                            value: 'yes',
                                            label: 'Yes'
                                        },
                                        {
                                            value: 'no',
                                            label: 'No'
                                        }
                                    ];
                                },
                                description: () => {
                                    return this.getDescription([
                                        '<p>The healthy homes regulations set out that certain apartments have a tailored formula to calculate the required heating capacity. These are apartments that are part of a building of at least three storeys, with six or more commercial or residential units.</p>',
                                        `<p>${this.getHelpLink(19, 'Understanding whether your home meets the apartment criteria', 'help-property_info')}</p>`
                                    ]);
                                }
                            },
                            observers: [
                                {
                                    key: 'value',
                                    call: ({ form, field, change }) => {
                                        if (change.newValue === 'yes') {
                                            this.$('homedetails.consentZone').set('value', '');
                                            this.$('homedetails.consentZoneCompliant').set('value', '');
                                            this.$('homedetails.franklinCouncil').set('value', '');
                                            this.$('homedetails.retrofitted2009').set('value', '');
                                        }
                                    }
                                }
                            ],
                            rules: 'required'
                        },
                        {
                            name: '1a',
                            type: 'radio',
                            value: '',
                            label: 'When did your home receive building consent?',
                            extra: {
                                options: () => {
                                    const options = [
                                        {
                                            value: 'Before 1978',
                                            label: '1977 or earlier'
                                        },
                                        {
                                            value: 'From 1978 to 2000',
                                            label: 'From 1978 to 2000'
                                        },
                                        {
                                            value: 'From 2001 to 2008',
                                            label: 'From 2001 to 2008'
                                        },
                                        {
                                            value: 'From 2009 to 2 Nov 2022',
                                            label: 'From 2009 to 2 November 2022'
                                        },
                                        {
                                            value: 'From 3 Nov 2022 to 30 Apr 2023',
                                            label: 'From 3 November 2022 to 30 April 2023'
                                        },
                                        {
                                            value: 'From 1 May 2023 to 1 Nov 2023',
                                            label: EnableNov2023Onwards ? 'From 1 May 2023 to 1 November 2023' : 'From 1 May 2023 onwards'
                                        }
                                    ];

                                    if (EnableNov2023Onwards) {
                                        options.push(
                                            {
                                                value: 'On or after 2 Nov 2023',
                                                label: 'From 2 November 2023 onwards'
                                            }
                                        );
                                    }

                                    return options;
                                },
                                description: () => {
                                    return this.getDescription([
                                        '<p>This helps us understand what building standards apply, so we can estimate what insulation and other features your home has.</p>',
                                        `<p>${this.getHelpLink(1, 'Finding property information', 'help-property_info')}</p>`
                                    ]);
                                },
                                showIf: {
                                    var: 'isApartment'
                                }
                            },
                            observers: [
                                {
                                    key: 'value',
                                    call: ({ form, field, change }) => {
                                        // Update the consentZone & consentZoneCompliant values if this field
                                        // is changed to 'From 2001 to 2008'. Otherwise reset them to empty.
                                        if (change.oldValue !== '' &&
                                            change.newValue === 'From 2001 to 2008') {
                                            this.updateConsentZoneQuestions();
                                        } else if (change.oldValue !== '' && change.newValue !== 'From 2001 to 2008') {
                                            this.$('homedetails.consentZone').set('value', '');
                                            this.$('homedetails.consentZoneCompliant').set('value', '');
                                            this.$('homedetails.franklinCouncil').set('value', '');
                                            this.$('homedetails.retrofitted2009').set('value', '');
                                        }
                                    }
                                }
                            ],
                            rules: 'required'
                        },
                        // {
                        //     name: '1a-1',
                        //     type: 'message',
                        //     value: '',
                        //     label: window.HTContent?.ConsentedAfter2009MessageHeading,
                        //     extra: {
                        //         message: window.HTContent?.ConsentedAfter2009MessageText,
                        //         showIf: {
                        //             '===': [{ var: '1a' }, 'From 2009 to 2 Nov 2022']
                        //         }
                        //     }
                        // },
                        {
                            name: '1b',
                            type: 'fieldset',
                            label: 'Where is your home?',
                            extra: {
                                description: () => {
                                    return this.getDescription([
                                        '<p>This helps us understand your local climate – for example, how cold it gets in winter.</p>'
                                    ]);
                                },
                                showIf: {
                                    var: '1a'
                                }
                            },
                            fields: [
                                {
                                    name: '1b-1',
                                    type: 'select',
                                    label: 'What region is your home in?',
                                    value: '',
                                    rules: 'required',
                                    extra: {
                                        options: () => {
                                            return this.regions;
                                        },
                                        placeholder: 'Select region'
                                    },
                                    observers: [
                                        {
                                            key: 'value', // can be any prop
                                            call: ({ form, field, change }) => {
                                                this.filteredCouncils = this.allCouncils
                                                    .filter(
                                                        (
                                                            value,
                                                            index,
                                                            self
                                                        ) => {
                                                            return (
                                                                Object.keys(
                                                                    value
                                                                )[0] ===
                                                                change.newValue
                                                            );
                                                        }
                                                    )
                                                    .map(obj => {
                                                        return Object.values(
                                                            obj
                                                        )[0];
                                                    })
                                                    .sort();

                                                // When the region changes, always reset the council,
                                                // consentZone and consentZoneCompliant values
                                                if (change.oldValue !== '' && change.oldValue !== change.newValue) {
                                                    this.$('homedetails.1b.1b-2').set('value', '');
                                                    this.$('homedetails.consentZone').set('value', '');
                                                    this.$('homedetails.consentZoneCompliant').set('value', '');
                                                    this.$('homedetails.franklinCouncil').set('value', '');
                                                }
                                            }
                                        }
                                    ]
                                },
                                {
                                    name: '1b-2',
                                    type: 'select',
                                    label: 'Which council area is your home in?',
                                    value: '',
                                    rules: 'required',
                                    extra: {
                                        options: () => {
                                            return this.filteredCouncils;
                                        },
                                        placeholder: 'Select council',
                                        showIf: {
                                            var: '1b-1'
                                        },
                                        description: () => {
                                            return this.getDescription([
                                                null,
                                                `<p>${this.getHelpLink(20, 'If you are not sure which district to choose, find out more about the boundaries', 'help-property_info')}</p>`
                                            ]);
                                        }
                                    },
                                    observers: [
                                        {
                                            key: 'value',
                                            call: ({ form, field, change }) => {
                                                // Update the consentZone & consentZoneCompliant values if this field changes and
                                                // the build period is changed to 'From 2001 to 2008'. Otherwise reset them to empty.
                                                if (this.$('homedetails.1a').get('value') === 'From 2001 to 2008') {
                                                    this.updateConsentZoneQuestions();
                                                } else {
                                                    this.$('homedetails.consentZone').set('value', '');
                                                    this.$('homedetails.consentZoneCompliant').set('value', '');
                                                }
                                                if (change.oldValue !== '' &&
                                                    change.newValue !== 'Hauraki District Council' &&
                                                    change.newValue !== 'Waikato District Council') {
                                                    this.$('homedetails.franklinCouncil').set('value', '');
                                                }
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: 'franklinCouncil',
                            type: 'radio',
                            value: '',
                            label: 'Was the building consent for your home issued by the former Franklin District Council?',
                            rules: 'required',
                            extra: {
                                options: () => {
                                    return [
                                        {
                                            value: 'yes',
                                            label: 'Yes'
                                        },
                                        {
                                            value: 'no',
                                            label: 'No'
                                        }
                                    ];
                                },
                                description: () => {
                                    return this.getDescription([
                                        '<p>This helps us understand which climate zone your home is in. Properties in some areas of Waikato and Hauraki District Council were previously part of the Franklin District Council.</p>',
                                        `<p>${this.getHelpLink(21, 'Find out more about the former Franklin District Council boundaries', 'help-property_info')}</p>`
                                    ]);
                                },
                                showIf: {
                                    and: [
                                        { '===': [{ var: 'isApartment' }, 'no'] },
                                        { '===': [{ var: '1a' }, 'From 2001 to 2008'] },
                                        {
                                            or: [
                                                { '===': [{ var: '1b-2' }, 'Hauraki District Council'] },
                                                { '===': [{ var: '1b-2' }, 'Waikato District Council'] }
                                            ]
                                        }
                                    ]
                                }
                            },
                            observers: [
                                {
                                    key: 'value',
                                    call: ({ form, field, change }) => {
                                        // Update the consentZone & consentZoneCompliant values if this field changes and
                                        // the build period is changed to 'From 2001 to 2008'. Otherwise reset them to empty.
                                        this.updateConsentZoneQuestions();
                                    }
                                }
                            ]
                        },
                        {
                            name: 'consentZone',
                            type: 'hidden',
                            value: ''
                        },
                        {
                            name: 'consentZoneCompliant',
                            type: 'radio',
                            value: '',
                            // not the label for this question is dynamic
                            // @TOTO see if we can split out this to m,ultiple questions
                            label: 'Did your home receive building consent on or after 30 September 2008?',
                            rules: 'required',
                            extra: {
                                options: () => {
                                    return [
                                        {
                                            value: 'yes',
                                            label: 'Yes'
                                        },
                                        {
                                            value: 'no',
                                            label: 'No'
                                        }
                                    ];
                                },
                                description: () => {
                                    return this.getDescription([
                                        '<p>This is the date the property received building consent when it was first built.</p>',
                                        `<p>${this.getHelpLink(22, 'Finding information on building consent', 'help-property_info')}</p>`
                                    ]);
                                },
                                showIf: {
                                    or: [
                                        {
                                            and: [
                                                { '===': [{ var: 'isApartment' }, 'no'] },
                                                { '===': [{ var: '1a' }, 'From 2001 to 2008'] },
                                                { var: '1b-1' },
                                                { var: '1b-2' },
                                                { '!==': [{ var: '1b-2' }, 'Hauraki District Council'] },
                                                { '!==': [{ var: '1b-2' }, 'Waikato District Council'] }
                                            ]
                                        },
                                        { var: 'franklinCouncil' }
                                    ]
                                }
                            },
                            observers: [
                                {
                                    key: 'value',
                                    call: ({ form, field, change }) => {
                                        if (change.oldValue !== '' && change.oldValue !== change.newValue) {
                                            this.$('homedetails.retrofitted2009').set('value', '');
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            name: 'retrofitted2009',
                            type: 'radio',
                            value: '',
                            label: 'Has your home been upgraded throughout with ceiling, wall and floor insulation and double-glazing that meets or exceeds the 2009 insulation and glazing standard?',
                            rules: 'required',
                            extra: {
                                options: () => {
                                    return [
                                        {
                                            value: 'yes',
                                            label: 'Yes'
                                        },
                                        {
                                            value: 'no',
                                            label: 'No'
                                        },
                                        {
                                            value: 'dont know',
                                            label: 'I don\'t know'
                                        }
                                    ];
                                },
                                description: () => {
                                    return this.getDescription([
                                        '<p>To qualify, renovated homes must have had insulation and double glazing installed in <strong>all</strong> external walls, floors and ceilings that meets the NZS 4218:2009 standard or above.</p>',
                                        '<p>If you are unsure you can choose ‘I don’t know’ and the tool will assume your property hasn’t met or exceeded the 2009 insulation and glazing standard.</p>',
                                        `<p>${this.getHelpLink(23, 'Understanding if your home meets or exceeds the 2009 insulation and glazing standard', 'help-property_info')}</p>`
                                    ]);
                                },
                                showIf: {
                                    or: [
                                        {
                                            and: [
                                                { '===': [{ var: 'isApartment' }, 'no'] },
                                                { '===': [{ var: '1a' }, 'Before 1978'] },
                                                { var: '1b-2' }
                                            ]
                                        },
                                        {
                                            and: [
                                                { '===': [{ var: 'isApartment' }, 'no'] },
                                                { '===': [{ var: '1a' }, 'From 1978 to 2000'] },
                                                { var: '1b-2' }
                                            ]
                                        },
                                        {
                                            and: [
                                                { '===': [{ var: 'isApartment' }, 'no'] },
                                                { '===': [{ var: '1a' }, 'From 2001 to 2008'] },
                                                { '===': [{ var: 'consentZoneCompliant' }, 'no'] }
                                            ]
                                        }
                                    ]
                                }
                            }
                        }
                    ]
                }
            ]
        };
    }
}
